import { classNames } from './classNames';

export function highlightNeedlesInHayStack(
  hayStack: string,
  needles: string[],
  indent: boolean,
): JSX.Element {
  const lowerHaystack = hayStack.toLowerCase();
  return (
    <span className={classNames('block truncate', indent && 'pr-5')}>
      {needles.map((text, index) =>
        text.toLowerCase() === lowerHaystack ? (
          <span className="font-bold" key={text + index}>
            {text}
          </span>
        ) : (
          text
        ),
      )}
    </span>
  );
}
